import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, EyeOutlined, IeOutlined, MessageOutlined, ReloadOutlined } from '@ant-design/icons';
import { Modal, Divider, Card, Pagination, Row, Drawer, List, Avatar, Space, Button, Switch } from 'antd';
import PageTitle from '@/components/PageTitle';
import { Form } from '@ant-design/compatible';
import TableActionBar from '@/components/TableActionBar';
import qs from 'qs';
import GuideForm from './FeedbackRequestForm';
import { checkPermission } from '@/utils/permission';
import { cleanObject, processHTML, stripHtml } from '@/utils/helpers';
import TextTruncate from 'react-text-truncate';
import ReactHtmlParser from 'react-html-parser';
import avatar from '@/assets/img/favicon.png';
import "react-quill/dist/quill.core.css";
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import CommentsComponent from '@/components/CommentsComponent';
import { fetchFeedbackRequestList, removeFeedbackRequest, fetchFeedbackRequestDetail, updateFeedbackRequest } from '@/redux/actions/feedbackRequestActions';
import BaseSelect from '@/components/Elements/BaseSelect';

const { confirm } = Modal;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/feedback-requests',
        breadcrumbName: 'Yêu cầu điều chỉnh',
    },
]

class FeedbackRequestList extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false, // loading table
            isOpenForm: false,
            currentData: null,
            openView: false,
        }

        this.routeName = 'feedback_requests';
        this.allowCreate = checkPermission(this.routeName, 'create');
        this.allowUpdate = checkPermission(this.routeName, 'update');
        this.allowDelete = checkPermission(this.routeName, 'remove');
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.fetchData(query);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.fetchData(query);
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    toggleOpenForm(isOpenForm, data = null) {
        this.setState({ isOpenForm: isOpenForm, currentData: data });
    }

    onEdit(id) {
        this.props.fetchFeedbackRequestDetail(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    onView(id) {
        this.props.fetchFeedbackRequestDetail(id).then(res => {
            this.setState({ openView: true, currentData: res });
        })
    }

    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeFeedbackRequest([id]).then(() => {
                this.fetchData()
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    fetchData(query) {
        this.setState({ isLoading: true });
        this.props.fetchFeedbackRequestList(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    loadData() {
        this.props.form.resetFields();
        this.props.fetchFeedbackRequestDetail(this.state.currentData.id).then(res => {
            this.setState({ currentData: res, submitting: false, });
        })
    }

    render() {
        var { feedbackRequests, pagination } = this.props;
        var { isLoading, isOpenForm, openView, currentData } = this.state;
        var query = qs.parse(this.props.location.search.slice(1));

        const IconText = ({ icon, text }) => (
            <Space>
                <span style={{ cursor: 'pointer' }}>
                    {React.createElement(icon)}&nbsp;
                    {text}
                </span>
            </Space>
        );

        return (
            <div>
                <PageTitle routes={routes} title="Yêu cầu điều chỉnh" />
                <div>
                    <TableActionBar
                        isShowAddButton={this.allowCreate}
                        isShowDeleteButton={false}
                        onAdd={() => this.toggleOpenForm(true)}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        <BaseSelect
                            options={[
                                { value: 1, label: 'Đã hoàn thành' },
                                { value: 0, label: 'Chưa hoàn thành' },
                            ]}
                            placeholder="Trạng thái"
                            defaultValue={parseInt(query.status) || null}
                            style={{ width: '200px' }}
                            onChange={(value) => this.onChangeFilter('status', value)}
                            className="table-button"
                        />
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.fetchData(query)}>Refresh</Button>
                    </TableActionBar>
                </div>
                <Card>
                    <List
                        itemLayout="vertical"
                        loading={isLoading}
                        rowKey='id'
                        size="large"
                        dataSource={feedbackRequests || []}
                        renderItem={item => {
                            const IconAction = [
                                <IconText icon={MessageOutlined} text={item.countComment || 0} key="list-vertical-message" />
                            ];
                            IconAction.push(<a onClick={() => this.onView(item.id)} key="list-vertical-view-on-pages"><EyeOutlined /> Xem nhanh</a>)
                            IconAction.push(<Link to={`/feedback-requests/${item.id}`} key="list-vertical-detail"><IeOutlined /> Xem chi tiết</Link>)

                            if (this.allowUpdate) {
                                IconAction.push(<a onClick={() => this.onEdit(item.id)} type='link' key="list-vertical-edit"><EditOutlined /> Chỉnh sửa</a>)
                            }
                            if (this.allowDelete) {
                                IconAction.push(<a onClick={() => this.openAlert(item.id)} type='link' key="list-vertical-delete"><DeleteOutlined /> Xóa</a>)
                            }
                            return (
                                <List.Item
                                    key={item.title}
                                    actions={IconAction}
                                    extra={
                                        <>
                                            <Switch
                                                onChange={(checked) => this.props.updateFeedbackRequest(item.id, { status: checked ? 1 : 0 })}
                                                defaultChecked={item.status}
                                                checkedChildren="Đã hoàn thành"
                                                unCheckedChildren="Chưa hoàn thành"
                                                disabled={!this.allowUpdate}
                                            />
                                        </>
                                    }
                                >
                                    <List.Item.Meta
                                        avatar={<Avatar src={avatar} />}
                                        title={item.title}
                                        description={
                                            <>
                                                <div>{moment(item.created_at).format('DD/MM/YYYY')} by: {item.created_user}</div>
                                            </>
                                        }
                                    />
                                    <TextTruncate line={3} truncateText="…" text={stripHtml(item.content)} />
                                </List.Item>
                            )
                        }
                        }
                    />
                    < Row justify="end" >
                        <Pagination {...pagination} onChange={(page) => this.onChangeFilter('page', page)} />
                    </Row >
                </Card >
                <GuideForm
                    visible={isOpenForm}
                    currentData={currentData}
                    loadData={() => this.fetchData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />

                <Drawer
                    visible={openView}
                    title={currentData ? currentData?.title : 'CHI TIẾT'}
                    onClose={() => this.setState({ openView: false })}
                    maskClosable={true}
                    width={isMobile ? '100%' : '70%'}
                    extra={
                        <>
                            <Switch
                                onChange={(checked) => this.props.updateFeedbackRequest(currentData?.id, { status: checked ? 1 : 0 })}
                                defaultChecked={currentData?.status}
                                checkedChildren="Đã hoàn thành"
                                unCheckedChildren="Chưa hoàn thành"
                                disabled={!this.allowUpdate}
                            />
                        </>
                    }
                >
                    {
                        openView ?
                            <div>
                                {
                                    currentData ? (
                                        <>
                                            <div className="view ql-editor training-img chingo-content-detail">
                                                {ReactHtmlParser(processHTML(currentData?.content))}
                                            </div>
                                            <Divider />
                                            <CommentsComponent
                                                reloadData={() => this.loadData()}
                                                commentsData={currentData.comments}
                                                type="feedback_requests"
                                                parentId={currentData?.id}
                                            />
                                        </>
                                    ) : null
                                }
                            </div>
                            : null
                    }
                </Drawer>
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        feedbackRequests: state.feedbackRequestReducer.feedbackRequests,
        pagination: state.feedbackRequestReducer.pagination,
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchFeedbackRequestList: (filter) => dispatch(fetchFeedbackRequestList(filter)),
        fetchFeedbackRequestDetail: (id) => dispatch(fetchFeedbackRequestDetail(id)),
        removeFeedbackRequest: (ids) => dispatch(removeFeedbackRequest(ids)),
        updateFeedbackRequest: (id, data) => dispatch(updateFeedbackRequest(id, data))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'FeedbackRequestList' })(FeedbackRequestList));
